import { useState } from "react";
import { C } from "../../constants";

export function Badge({ status }) {
  const m = {
    approved: { bg: "#D1FAE5", c: "#065F46" },
    shipped: { bg: "#DBEAFE", c: "#1E40AF" },
    pending: { bg: "#FEF3C7", c: "#92400E" },
    review: { bg: "#E0E7FF", c: "#3730A3" },
    delivered: { bg: "#D1FAE5", c: "#065F46" },
    quoted: { bg: "#D1FAE5", c: "#065F46" },
  };
  const s = m[status] || m.pending;
  return (
    <span style={{ display: "inline-block", padding: "2px 10px", borderRadius: "999px", fontSize: "11px", fontWeight: 600, letterSpacing: "0.03em", textTransform: "uppercase", backgroundColor: s.bg, color: s.c }}>
      {status}
    </span>
  );
}

export function StatCard({ label, value, icon: Icon, color, sub, large }) {
  return (
    <div style={{ background: C.white, borderRadius: 14, padding: large ? "24px 28px" : "22px 24px", border: `1px solid ${C.border}`, display: "flex", alignItems: "flex-start", gap: 16, transition: "box-shadow 0.2s,transform 0.2s", cursor: "default" }}
      onMouseEnter={e => { e.currentTarget.style.boxShadow = "0 8px 24px rgba(0,0,0,0.05)"; e.currentTarget.style.transform = "translateY(-2px)"; }}
      onMouseLeave={e => { e.currentTarget.style.boxShadow = "none"; e.currentTarget.style.transform = "translateY(0)"; }}>
      <div style={{ width: 44, height: 44, borderRadius: 12, background: `${color}12`, display: "flex", alignItems: "center", justifyContent: "center", color, flexShrink: 0 }}><Icon /></div>
      <div>
        <div style={{ fontSize: large ? 24 : 28, fontWeight: 700, color: C.t1, lineHeight: 1 }}>{value}</div>
        <div style={{ fontSize: 13, color: C.t2, marginTop: 4 }}>{label}</div>
        {sub && <div style={{ fontSize: 11, color: C.t3, marginTop: 2 }}>{sub}</div>}
      </div>
    </div>
  );
}

export function BrandTable({ title, data, brands, color }) {
  const fmt = n => "$" + n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const total = Object.values(data).reduce((a, b) => a + b, 0);
  return (
    <div style={{ background: C.white, borderRadius: 14, border: `1px solid ${C.border}`, overflow: "hidden" }}>
      <div style={{ padding: "16px 20px", borderBottom: `1px solid ${C.border}`, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h3 style={{ fontSize: 14, fontWeight: 600, color: C.t1, margin: 0 }}>{title}</h3>
        <span style={{ fontSize: 15, fontWeight: 700, color }}>{fmt(total)}</span>
      </div>
      {brands.map((b, i) => (
        <div key={b} style={{ padding: "10px 20px", display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: i < brands.length - 1 ? `1px solid ${C.border}` : "none" }}>
          <span style={{ fontSize: 13, color: C.t2 }}>{b}</span>
          <span style={{ fontSize: 13, fontWeight: 600, color: C.t1 }}>{fmt(data[b] || 0)}</span>
        </div>
      ))}
    </div>
  );
}

export function HoverCard({ onClick, color, emoji, title, subtitle, warning, arrow }) {
  const [h, setH] = useState(false);
  return (
    <button onClick={onClick} onMouseEnter={() => setH(true)} onMouseLeave={() => setH(false)}
      style={{ flex: "1 1 0", minWidth: 200, padding: "28px 22px", borderRadius: 16, border: `2px solid ${h ? color : C.border}`, background: h ? `${color}06` : C.white, cursor: "pointer", textAlign: "left", transition: "all 0.25s", boxShadow: h ? `0 8px 28px ${color}15` : "0 2px 8px rgba(0,0,0,0.03)", display: "flex", flexDirection: "column", gap: 14, fontFamily: "inherit", transform: h ? "translateY(-2px)" : "none" }}>
      <div style={{ width: 52, height: 52, borderRadius: 14, background: `${color}12`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 26 }}>{emoji}</div>
      <div>
        <div style={{ fontSize: 16, fontWeight: 700, color: C.t1, marginBottom: 5 }}>{title}</div>
        <div style={{ fontSize: 13, color: C.t2, lineHeight: 1.55 }}>{subtitle}</div>
      </div>
      {arrow && <div style={{ color: C.t3, alignSelf: "flex-end", marginTop: "auto" }}><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6" /></svg></div>}
    </button>
  );
}

export function SubCard({ onClick, color, emoji, label, desc }) {
  const [h, setH] = useState(false);
  return (
    <button onClick={onClick} onMouseEnter={() => setH(true)} onMouseLeave={() => setH(false)}
      style={{ padding: "22px 24px", borderRadius: 14, border: `1.5px solid ${h ? color : C.border}`, background: h ? `${color}06` : C.white, cursor: "pointer", textAlign: "left", transition: "all 0.2s", display: "flex", alignItems: "center", gap: 16, fontFamily: "inherit", boxShadow: h ? `0 4px 16px ${color}12` : "none", transform: h ? "translateY(-1px)" : "none" }}>
      <div style={{ width: 44, height: 44, borderRadius: 12, background: `${color}12`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22, flexShrink: 0 }}>{emoji}</div>
      <div style={{ flex: 1 }}><div style={{ fontSize: 15, fontWeight: 600, color: C.t1 }}>{label}</div><div style={{ fontSize: 12.5, color: C.t3, marginTop: 2 }}>{desc}</div></div>
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={C.t3} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6" /></svg>
    </button>
  );
}

export function GridCard({ onClick, color, emoji, label, desc }) {
  const [h, setH] = useState(false);
  return (
    <button onClick={onClick} onMouseEnter={() => setH(true)} onMouseLeave={() => setH(false)}
      style={{ padding: "22px 18px", borderRadius: 14, border: `1.5px solid ${h ? color : C.border}`, background: h ? `${color}06` : C.white, cursor: "pointer", textAlign: "left", transition: "all 0.2s", fontFamily: "inherit", display: "flex", flexDirection: "column", gap: 10, boxShadow: h ? `0 6px 20px ${color}12` : "0 1px 4px rgba(0,0,0,0.03)", transform: h ? "translateY(-2px)" : "none" }}>
      <div style={{ width: 42, height: 42, borderRadius: 12, background: `${color}12`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22 }}>{emoji}</div>
      <div><div style={{ fontSize: 14, fontWeight: 600, color: C.t1 }}>{label}</div><div style={{ fontSize: 12, color: C.t3, marginTop: 2 }}>{desc}</div></div>
    </button>
  );
}

// Shared form styles
export const inputStyle = { width: "100%", padding: "12px 14px", borderRadius: "10px", border: `1px solid ${C.border}`, background: C.grayBg, color: C.t1, fontSize: "14px", outline: "none", transition: "border-color 0.2s,box-shadow 0.2s", boxSizing: "border-box", fontFamily: "inherit" };
export const selectStyle = { ...inputStyle, appearance: "auto" };
export const labelStyle = { display: "block", fontSize: 12, fontWeight: 600, color: C.t2, letterSpacing: "0.05em", textTransform: "uppercase", marginBottom: 4 };
export const labelSpanish = { display: "block", fontSize: 11, color: C.t3, fontStyle: "italic", marginBottom: 6 };
export const inputFocus = e => { e.target.style.borderColor = C.navy; e.target.style.boxShadow = `0 0 0 3px ${C.navy}12`; };
export const inputBlur = e => { e.target.style.borderColor = C.border; e.target.style.boxShadow = "none"; };
